<app-container>
  <app-header></app-header>
  <div class="product-detail-container">
    @if (product(); as p) {
      <div class="product-detail-box">
        <p-toast></p-toast>
        <div class="back-link">
          <a [routerLink]="backLink()"><span class="pi pi-chevron-left"></span> Terug naar overzicht</a>
        </div>

        <div class="product-main">
          <div class="product-images">
            @if (p.images && p.images.length > 0) {
              <div class="main-image-container">
                <div class="product-image-wrapper" (mousemove)="handleMouseMove($event)" (mouseleave)="handleMouseLeave()" (click)="showPopup()">
                  <img [ngSrc]="selectedImage()!" [alt]="title()" width="1000" height="1000" priority 
                       [style.transform-origin]="zoomOrigin()"
                       style="object-fit: contain; object-position: top; width: 100%; height: 100%;"/>
                </div>
              </div>

              @if (p.images.length > 1) {
                <div class="thumbnail-list">
                  @for (image of p.images; track image; let i = $index) {
                    <div class="thumbnail-wrapper" [class.active]="selectedImageIndex() === i" (click)="selectedImageIndex.set(i)">
                      <img [ngSrc]="image" [alt]="title()" width="150" height="150" style="object-fit: cover; width: 100%; height: 100%;"/>
                    </div>
                  }
                </div>
              }
            }
          </div>

          <div class="product-info">
            <h1 class="product-title">{{ title() }}</h1>

            <div class="product-attributes">
              @for (attr of otherAttributes(); track attr.attributeId) {
                <p><strong>{{ attr.name }}:</strong> {{ attr.displayValue }}</p>
              }
            </div>

            @if (remark()) {
              <div class="product-description">
                <h3>Omschrijving</h3>
                <p>{{ remark() }}</p>
              </div>
            }

            <div class="sharing">
              <h3>Deel dit product</h3>
              <div class="sharing-icons">
                <button (click)="copyLink()" pTooltip="Kopieer link" tooltipPosition="top">
                  <span class="pi pi-copy"></span>
                </button>
                <button (click)="shareOnFacebook()" pTooltip="Deel op Facebook" tooltipPosition="top">
                  <span class="pi pi-facebook"></span>
                </button>
                <button (click)="shareOnInstagram()" pTooltip="Deel op Instagram" tooltipPosition="top">
                  <span class="pi pi-instagram"></span>
                </button>
              </div>
            </div>

            @if (productCode()) {
              <div class="product-code-section">
                <h2 class="product-code">{{ productCode() }}</h2>
              </div>
            }

            <div class="product-actions">
              <a [href]="'mailto:info@hetraaymakersantiek.nl?subject=Interesse in product: ' + title() + ' (' + productCode() + ')'" class="email-btn">
                <span class="pi pi-envelope"></span> Stuur email over dit product
              </a>
            </div>
          </div>
        </div>

        <p-dialog [visible]="displayImagePopup()" (onHide)="displayImagePopup.set(false)" [modal]="true" [dismissableMask]="true" [closable]="true" 
                  [showHeader]="false" [style]="{ width: '90vw', maxWidth: '1000px' }" [baseZIndex]="20000" styleClass="image-popup-dialog">
          <div class="popup-image-container" (click)="displayImagePopup.set(false)">
            <img [src]="selectedImage()" [alt]="title()" (click)="$event.stopPropagation()"/>
          </div>
        </p-dialog>
      </div>
    } @else {
      <div class="product-not-found">
        <p>Product niet gevonden.</p>
        <a routerLink="/producten">Terug naar het overzicht</a>
      </div>
    }
  </div>
</app-container>
